import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { Inventory } from "./pages/Inventory";
import { AddItem } from "./pages/AddItem";
import { ItemDetail } from "./pages/ItemDetail";
import { GroceryList } from "./pages/GroceryList";
import { Settings } from "./pages/Settings";

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-stone-500 dark:text-stone-400">
        Loading…
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Inventory />} />
        <Route path="/add" element={<AddItem />} />
        <Route path="/products/:id" element={<ItemDetail />} />
        {/* Legacy lot-based URL — redirect to inventory list since we no
            longer have a per-lot detail page. */}
        <Route path="/items/:id" element={<Navigate to="/" replace />} />
        <Route path="/list" element={<GroceryList />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
